import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=a09755aa&scoped=true&"
import script from "./Classroom.vue?vue&type=script&lang=js&"
export * from "./Classroom.vue?vue&type=script&lang=js&"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=a09755aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a09755aa",
  null
  
)

export default component.exports